<template>
    <div class="question-example-phonetic-vowel">
        <span class="question-example-phonetic-vowel__label">ÖRNEK:</span>
        <span class="question-example-phonetic-vowel__surface-structure">/ {{ phonemicExample }} /</span>
        <span class="question-example-phonetic-vowel__separator">→</span>
        <span class="question-example-phonetic-vowel__deep-structure">[ {{ phoneticExample }} ]</span>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            phonemicExample: { type: String, default: 'tek' },
            phoneticExample: { type: String, default: 'tʰɛc' },
        },
    };
</script>

<style scoped src="@/css/components/question-example-phonetic-vowel.css"></style>